/**
 * Reprerents parameters for MutationType.LOGIN_REQUEST mutation
 */
export class LoginRequestMutationParams {
    public constructor(
        public readonly username: string,
        public readonly password?: string
    ) {}
}
